"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const colors_1 = require("../../assets/jss/colors");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const config_1 = require("../../config/config");
const styles = (theme) => (0, styles_1.createStyles)({
    textDark87: {
        color: color(theme.palette.common.black).alpha(0.87).rgb().string()
    },
    textDark60: {
        color: color(theme.palette.common.black).alpha(0.6).rgb().string()
    },
    textDark82: {
        color: color(theme.palette.common.black).alpha(0.82).rgb().string()
    },
    textSecondary: {
        color: color(theme.palette.secondary.dark).rgb().string()
    },
    buttonDark: {
        backgroundColor: color(theme.palette.secondary.main).rgb().string()
    },
    uppercase: {
        textTransform: 'uppercase'
    },
    container: material_kit_pro_react_1.container,
    filterContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    filterButtonSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    filterText: {
        marginRight: theme.spacing(2),
        marginBottom: 0
    },
    filterButtonColors: config_1.config.internalConfig.ENABLE_ALT_TICKET_CARD_STYLE
        ? {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        }
        : {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
    filterButtonColorsDark: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    tabButton: {
        '&.Mui-focusVisible': {
            boxShadow: `0 0 0px 2px white, 0 0 0 6px ${colors_1.default.themeColors.boxShadowColor.hex()}  !important`,
            outline: `${colors_1.default.themeColors.black.hex()} !important`,
            outlineOffset: '2px !important',
            transition: 'background-color 0.3s ease, outline 0.3s ease !important'
        }
    },
    filterButton: {
        padding: 6
    },
    filterFab: {
        padding: 6
    },
    dialogBackdrop: {
        backgroundColor: color(config_1.config.themeColors.grayColor.hex()).alpha(0.8).rgb().string()
    },
    dialog: {
        backgroundColor: theme.palette.background.default
    },
    dialogDark: {
        backgroundColor: '#f1f1f1'
    },
    dialogHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        paddingTop: theme.spacing(4)
    },
    filterCategoryContainer: {
        marginTop: theme.spacing(2)
    },
    categoryDetails: {
        marginTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        paddingTop: 0,
        paddingBottom: 0
    },
    categoryDetailsInner: {
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingLeft: theme.spacing(),
        paddingRight: theme.spacing(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    filterItemBg: {
        backgroundColor: theme.palette.background.default
    },
    filterItemBgDark: {
        backgroundColor: color(theme.palette.common.black).alpha(0.08).rgb().string(),
        color: color(theme.palette.common.black).alpha(0.6).rgb().string()
    },
    filterItem: {
        borderRadius: 30,
        minWidth: 56,
        margin: theme.spacing() / 2,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    largeFilterItem: {
        minHeight: 42,
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing()
    },
    filterItemSelected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        }
    },
    filterItemSelectedDark: {
        backgroundColor: color(theme.palette.secondary.main).rgb().string(),
        color: color(theme.palette.common.black).alpha(0.82).rgb().string(),
        '&:hover': {
            backgroundColor: color(theme.palette.secondary.main).rgb().string()
        }
    },
    filtersItemSelected: {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.text.primary,
        textTransform: 'none'
    },
    filterSelectedSection: {
        flexDirection: 'row',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        alignItems: 'center'
    },
    tabBar: {
        overflow: 'hidden',
        borderRadius: '4px',
        backgroundColor: theme.palette.primary.main,
        marginTop: theme.spacing()
    },
    tabFilterButton: {
        color: theme.palette.common.black,
        backgroundColor: theme.palette.common.white,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginLeft: 'auto',
        [theme.breakpoints.up('xs')]: {
            marginTop: 0,
            marginBottom: 0
        }
    },
    filtersActions: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    customDateFiltersButton: {
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(3)
    },
    filterBtn: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    tabBarSelect: {
        margin: theme.spacing(),
        marginLeft: theme.spacing(2)
    },
    tabBarSelectInput: {
        borderRadius: 4,
        position: 'relative',
        border: 0,
        backgroundColor: theme.palette.primary.contrastText.getLowEmphasis(),
        color: theme.palette.primary.contrastText,
        fontSize: 16,
        '&:focus': {
            borderRadius: 4,
            position: 'relative',
            border: 0,
            padding: theme.spacing(),
            backgroundColor: theme.palette.background.paper.getLowEmphasis(),
            color: theme.palette.common.white.getMediumEmphasis()
        },
        '& svg': {
            color: theme.palette.primary.contrastText
        },
        '&:*': {
            border: 0
        },
        '&:after': {
            border: 0
        },
        '&:hover': {
            border: 0
        }
    },
    dateRange: {
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'row',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        }
    },
    dateField: {
        width: '100%'
    },
    spaceRight: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(2)
        }
    },
    closeButton: {
        '&:focus': {
            backgroundColor: theme.palette.action.focus
        }
    }
});
exports.default = styles;
//# sourceMappingURL=FilterSectionStyle.js.map